export default __webpack_public_path__ + "static/ASIA-TRADE-559bb178e522e0ff6bba9f4ff7a96c06.svg";